export enum NameLink {
	COMMON_PROJECTS = 'ИПР',
	USER_PROJECTS = 'Проекты',
	USER_ARCHIVE = 'Архив',
	PURCHASES = 'Закупки',
}
export enum NameLinkShrt {
	COMMON_PROJECTS = 'ИПР',
	USER_PROJECTS = 'Проекты',
	USER_ARCHIVE = 'Архив',
	PURCHASES = 'Закупки',
}
